"use client"
// src/modules/footer/footer-newsletter.tsx
import Input from "@a24/form/Input";
import Label from "@a24/ui/Label";
import { useRef, useState } from "react";
import Icon from "@a24/ui/Icon";
import { jsx, jsxs } from "react/jsx-runtime";
var FooterNewsletter = ({
  labels = {
    newsletterInput: "Enter your email",
    newsletterLabel: "Newsletter Sign-Up",
    newsletterText: "By entering your email you are consenting to receive emails from Cherry Lane Theatre and agree with our Terms & Conditions."
  }
}) => {
  const ref = useRef(null);
  const [showError, setShowError] = useState(false);
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: "mc_embed_shell",
      className: "w-full max-w-100 sm:max-w-78 md:w-[26.25rem] relative mt-21 sm:mt-14 [@media(min-height:1024px)]:mt-[10.375rem]",
      children: /* @__PURE__ */ jsxs("div", { id: "mc_embed_signup", children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            text: labels.newsletterLabel,
            className: "text-heritage-off-white-full text-body-xs uppercase"
          }
        ),
        /* @__PURE__ */ jsx(
          "form",
          {
            action: "https://cherrylanetheatre.us3.list-manage.com/subscribe/post?u=1cc4dfceca56ee8fa5a6f1a0c&id=a0742e6e3d&f_id=00a0d9e3f0",
            method: "post",
            id: "mc-embedded-subscribe-form",
            name: "mc-embedded-subscribe-form",
            className: "validate",
            onSubmit: (e) => {
              setShowError(false);
              const isValid = ref.current?.value.match(
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
              );
              if (!isValid) {
                e.preventDefault();
                setShowError(true);
              }
            },
            children: /* @__PURE__ */ jsxs("div", { id: "mc_embed_signup_scroll relative", children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  placeholder: labels.newsletterInput,
                  id: "mce-EMAIL",
                  name: "EMAIL",
                  innerWrapperClassName: "!border-t-0 !bg-transparent !border-l-0 !border-r-0 !border-b !rounded-none !border-heritage-off-white-80 hover:!border-heritage-off-white-80 !pl-0",
                  labelClassName: "!text-heritage-off-white-full text-label-base",
                  className: "mc-field-group !text-heritage-off-white-full body-lg pl-0 placeholder:text-heritage-off-white-full placeholder:opacity-48",
                  type: "email",
                  formNoValidate: true,
                  ref
                }
              ),
              /* @__PURE__ */ jsx("div", { className: "clear absolute top-[1em] right-0 flex items-center", children: /* @__PURE__ */ jsx(
                "button",
                {
                  type: "submit",
                  "aria-label": "subscribe",
                  id: "mc-embedded-subscribe",
                  className: "button-arrow-form h-full group",
                  children: /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "arrow-right",
                      SVGClassName: "w-[0.875rem] h-auto",
                      className: "group-hover:translate-x-1 transition-translate"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ jsxs("div", { id: "mce-responses", className: "clear", children: [
                /* @__PURE__ */ jsx("div", { className: "response error-message", id: "mce-error-response" }),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "response error-message",
                    id: "mce-success-response"
                  }
                ),
                showError && /* @__PURE__ */ jsx("div", { className: "response error-message", children: "Please enter a valid email address." })
              ] }),
              /* @__PURE__ */ jsx("div", { "aria-hidden": "true", children: /* @__PURE__ */ jsx(
                "input",
                {
                  type: "text",
                  name: "b_1cc4dfceca56ee8fa5a6f1a0c_a0742e6e3d",
                  tabIndex: -1,
                  defaultValue: ""
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ jsx("p", { className: "text-heritage-off-white-full text-body-sm", children: labels.newsletterText })
      ] })
    }
  );
};
var footer_newsletter_default = FooterNewsletter;

export {
  footer_newsletter_default
};
